import { render, staticRenderFns } from "./HiddenPrice.vue?vue&type=template&id=99d12d3a&"
import script from "./HiddenPrice.vue?vue&type=script&lang=js&"
export * from "./HiddenPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports